import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { useCaptureIntervention } from "../../../hooks/Capture";
import CaptureInterventions from "../Intervention/CaptureInterventions";

interface InterventionTabProps {
  captureId: string;
  handleError: (error: any) => void;
  canEdit: boolean;
}

const InterventionTab: React.FC<InterventionTabProps> = ({ captureId, handleError, canEdit }) => {
  const { interventionsData, isPending, createIntervention, updateIntervention, deleteIntervention } = useCaptureIntervention(captureId);

  if (isPending && interventionsData.length === 0) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <CaptureInterventions
      interventionsData={interventionsData}
      canEdit={canEdit}
      onCreate={async (values) => {
        await createIntervention(values).catch(handleError);
      }}
      onUpdate={async (id, values) => {
        await updateIntervention({ interventionId: id, values }).catch(handleError);
      }}
      onDelete={async (id) => {
        await deleteIntervention(id).catch(handleError);
      }}
    />
  );
};

export default InterventionTab;
